import { applySeo } from "../lib/seo";
import { useEffect } from "react";
import { CONTACT, TESTIMONIALS_PAGE } from "../data/site";
import { MaskedLines, Reveal } from "../components/site/Reveal";
import { Testimonials } from "../components/site/Testimonials";
import { CTABand } from "../components/site/CTABand";

export default function TestimonialsPage() {
  useEffect(() => {
    applySeo({ paths: ["/testimonials/"], fallbackTitle: "Testimonials | Cedar Views, Surrey & Hampshire" });
    window.scrollTo(0, 0);
  }, []);

  return (
    <main data-testid="testimonials-page" className="pt-32">
      <section className="max-w-[1400px] mx-auto px-6 lg:px-10 pt-12">
        <Reveal><p className="overline-x mb-6">Rated {CONTACT.rating} · {CONTACT.reviews} reviews</p></Reveal>
        <MaskedLines as="h1" lines={[TESTIMONIALS_PAGE.heading]} delay={0.15}
          className="font-display tracking-tighter text-5xl sm:text-6xl lg:text-8xl text-white leading-[0.95]" />
      </section>
      <Testimonials />
      <CTABand />
    </main>
  );
}
